"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* Copyright 2019-2022 The MathWorks, Inc. */
define([], function () {
  'use strict'; // Switch out iFrame for direct XHR requests
  // but keeping all the original APIs in place.
  // This is not an ideal implimentation but allows
  // us to remove our dependecy on iFrameProxy HTML files
  // and make sure CORS is working for teams

  return /*#__PURE__*/function () {
    function _class(options) {
      _classCallCheck(this, _class);

      this._xhr = null;
      this._uploadDestinationUrl = options.uploadDestinationUrl;
      this._computeToken = options.computeToken;
      this._routingkey = options.routingkey;
      this._fileDestination = options.fileDestination;
      this._csrfToken = options.csrfToken;

      this._postMessage = function (message) {
        options.postMessage(message);
      };
    }

    _createClass(_class, [{
      key: "_postMessageToParent",
      value: function _postMessageToParent(message) {
        this._postMessage({
          data: message
        });
      }
    }, {
      key: "_createFormDataFromFileList",
      value: function _createFormDataFromFileList(fileList) {
        var formData = new window.FormData();
        var FORM_DATA_FIELD_NAME = 'uploadFileName'; // The server requires this particular name.

        for (var i = 0; i < fileList.length; i++) {
          var file = fileList[i];
          formData.append(FORM_DATA_FIELD_NAME, file, file.name);
        }

        return formData;
      }
    }, {
      key: "_createAndSendXhr",
      value: function _createAndSendXhr(formData) {
        var _this = this;

        this._xhr = new XMLHttpRequest();

        this._xhr.upload.onprogress = function (event) {
          _this._postMessageToParent({
            type: 'updateProgress',
            loaded: event.loaded,
            total: event.total
          });
        };

        this._xhr.onload = function () {
          _this._postMessageToParent({
            type: 'uploadFinished',
            status: _this._xhr.status,
            response: _this._xhr.response
          });
        };

        this._xhr.onerror = function () {
          _this._postMessageToParent({
            type: 'uploadError',
            status: _this._xhr.status,
            response: _this._xhr.response
          });
        };

        this._xhr.open('POST', "".concat(this._uploadDestinationUrl, "?dest=").concat(this._fileDestination, "&computeToken=").concat(this._computeToken, "&routingkey=").concat(this._routingkey, "&csrfToken=").concat(this._csrfToken), true);

        this._xhr.withCredentials = true;

        this._xhr.send(formData);
      }
    }, {
      key: "handleMessage",
      value: function handleMessage(event) {
        if (event.data instanceof FileList) {
          var formData = this._createFormDataFromFileList(event.data);

          this._createAndSendXhr(formData);

          return;
        }

        if (event.data === 'cancelUpload') {
          if (this._xhr) {
            this._xhr.abort();
          }

          this._postMessageToParent({
            type: 'uploadCanceled'
          });
        }
      }
    }]);

    return _class;
  }();
});
//# sourceMappingURL=ReplaceUploadIframe.js.map
